import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableBody,
  TableContainer,
  TableCell,
  Table,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  ModalDeleteConfirm,
  TableHeader,
  Title,
  Loading,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import { useDatatablesServerSide, useDatatables } from "App/hooks";
import { getPembayaranAll, RESET_STATE_FORM_FILTER } from "./helpers";
import { headCells } from "../Pembayaran/helpers";
import {
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
} from "App/utils/helpers";

import { WMS_PBF_PEMBAYARAN } from "App/constants";
import { TableItemListPembayaran } from "../Pembayaran/TableListPembayaran";
import { deletePembayaranPembelianByID } from "../Pembayaran/helpers";
import FormFilterDaftarPembayaran from "./FormFilterDaftarPembayaran";
import { getPembelianById } from "../PembelianWMS/helpers";
export default function DaftarPembayaran({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [pembayaranID, setPembayaranID] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const handleClickUpdate = async (row) => {
    setLoading(true);
    Promise.resolve()
      .then(() => {
        changeParentData("");
        changeMenu(WMS_PBF_PEMBAYARAN);
      })
      .then(async () => {
        const response = await getPembelianById(row.pembelian_id);
        if (response.state) {
          await changeParentData({
            id: row.id,
            tanggal_masuk: defaultDateInputDisplay(row.tanggal_masuk, true),
            tipe_pembayaran_id: row.tipe_pembayaran_id,
            kas_id: row.kas_id,
            kas_name: row.kas_name,
            jumlah_bayar2: formatNumber(response.data.bayar),
            pembelian_id: row.pembelian_id,
            total_pembelian: response.data.totalPembelian,
          });

          await changeMenu(WMS_PBF_PEMBAYARAN);
          await changeTitle(WMS_PBF_PEMBAYARAN);
          handleClickMenu({
            code: WMS_PBF_PEMBAYARAN,
            name: "Pembayaran",
          });

          setLoading(false);
        } else {
          setLoading(false);
          defaultToastError("Pembelian tidak ditemukan");
        }
      });
  };

  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      await setNewDataPembayaranByPembelian();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataPembayaranByPembelian = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);

    const res = await getPembayaranAll(formFilter, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewDataPembayaranByPembelian });

  async function deleteList() {
    const res = await deletePembayaranPembelianByID(pembayaranID);

    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewDataPembayaranByPembelian();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const clickDelete = (id) => {
    setPembayaranID(id);
    setShowModalDeleteConfirm(true);
  };

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar Pembayaran Pembelian"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}>
          <FormFilterDaftarPembayaran
            formFilter={formFilter}
            setFormFilter={setFormFilter}
            setNewData={setNewDataPembayaranByPembelian}
          />
          <Loading show={loading} />

          <TableDaftarPembayaran
            rows={rows}
            classes={classes}
            clickDelete={clickDelete}
            handleClickUpdate={handleClickUpdate}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

const TableDaftarPembayaran = ({
  rows,
  classes,
  clickDelete,
  handleClickUpdate,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "jumlah_bayar",
    orderByRow: ["jumlah_bayar"],
  });

  return (
    <TableContainer className='custom-scrollbar'>
      <Table
        className={classes.table}
        aria-labelledby='tableTitle'
        size={"medium"}
        aria-label='enhanced table'>
        <TableHeader
          classes={classes}
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
          rowCount={length}
          headCells={headCells}
        />
        <TableBody>
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableItemListPembayaran
                row={row}
                key={index}
                clickDelete={clickDelete}
                index={index}
                withUpdate={true}
                clickUpdate={handleClickUpdate}
              />
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align='center' colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
